export { GridChartsModule } from "./gridChartsModule";



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ag-grid-enterprise/charts/dist/es6/main.js
// module id = 1174
// module chunks = 0